// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchParams = (name, value) => ({
    name,
    type: actions.UPDATE_DEALER_SEARCH_PARAMS,
    value
});



// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/update-search-params.js